module.exports = __webpack_public_path__ + "img/30a-indicadores-osm-situacoes-mes.99baac52.png";